<div class="remova_padding topo" class="{{tema}}">
  <nav class="navbar navbar-expand-lg navbar-light bg-light shadow" >
    <div class="row">
      <div class="pl-2 span3 text-left" style="margin-top: 3px;">
        <button class="btn btn-outline-blue btn-rounded" (click)="voltar()" style="margin-right: 5px;" *ngIf="!exibirFechar">
          <i class="fa fa-arrow-left ct-point" ></i>
        </button>
        <button class="btn btn-outline-blue btn-rounded" (click)="fechar()" style="margin-right: 5px;" *ngIf="exibirFechar">
          <i class="fas fa-times"></i>
        </button>
      </div>
      <div class="pl-1 span6 text-center"><h4 class="titulo">
        <i class="{{icon}}" *ngIf="icon"></i>
        {{titulo}}</h4></div>
    </div>
  </nav>
</div>
